export default __webpack_public_path__ + "../staticImages/sprite-footer-google-pay-2x.png";